module.exports = __webpack_public_path__ + "static/media/13ITC1.9f72b5f7.jpg";